export const isAiAssistantEnabled = (isAdmin, isWidgetAvailable) => {
  // Server-side kill switch — overrides isAdmin and show_ai_assistant for everyone.
  if (window.disable_ai_agent) return false;

  const flagEnabled = Boolean(isAdmin) || Boolean(window.show_ai_assistant);
  return flagEnabled && Boolean(isWidgetAvailable);
};
